
import LocationSlash from "../../../assets/duotone/LocationSlash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LocationSlashIcon({ className, dataTestid = "LocationSlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LocationSlash data-testid={dataTestid} className={classes} {...rest} />
  );
}
